import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full border-b border-neutral-200 bg-white/80 backdrop-blur-md" data-id="element-76">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="flex items-center gap-2" data-id="element-78">
          <div className="h-4 w-4 rounded-sm bg-[#FF6B1A]" data-id="element-79" />
          <span className="text-sm font-semibold tracking-tight text-neutral-900" data-id="element-80">
            indiastartups.in
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-6" data-id="element-81">
          <a href="#" className="text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-82">
            Startups
          </a>
          <a href="#" className="text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-83">
            Categories
          </a>
          <a href="#" className="text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-84">
            About
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-85">
          <a href="#" className="hidden sm:inline-flex h-9 items-center justify-center rounded-md bg-black px-4 text-sm font-medium text-white transition-colors hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-400 focus:ring-offset-2" data-id="element-86">
            Submit a startup
          </a>
        </div>
      </div>
    </header>;
}